import axios from 'axios';
import { jwtDecode } from "jwt-decode";

export async function handleLogout() {
    localStorage.clear();
    axios.defaults.headers.common['Authorization'] = null;
}

export async function handleTokenData(token: string, refreshToken: string) {
    console.log("handleTokenData")
    localStorage.setItem('access_token', token);
    localStorage.setItem('refresh_token', refreshToken);

    const decodedToken: any = jwtDecode(token);

    const keyusername = decodedToken.preferred_username || '';
    localStorage.setItem('keyusername', keyusername);

    const keyidazienda = decodedToken.keyidazienda || 2;
    localStorage.setItem('keyidazienda', keyidazienda);

    const keycodclifor = decodedToken.keycodclifor || 0;
    localStorage.setItem('keycodclifor', keycodclifor);

    const keycoddip = decodedToken.keycoddip || 'NN';
    localStorage.setItem('keycoddip', keycoddip);
    localStorage.setItem('coddip', keycoddip);

    // const roles = decodedToken.realm_access?.roles as string[] | undefined;
    //
    // if (Array.isArray(roles)) {
    //   const keyrole = roles.find((role) => role.startsWith("Time")) || decodedToken.sub;
    //   localStorage.setItem('keyrole', keyrole);
    // } else {
    //   console.error("Roles are not defined or not an array.");
    //   localStorage.setItem('keyrole', decodedToken.sub);
    // }

    const roles = decodedToken.realm_access?.roles as string[] || [];
        if (Array.isArray(roles)) {
         const timeprevRoles = roles.filter((role) => {const r = role.toLowerCase();
             return r.startsWith("time") || r.startsWith("preventivi") || r.startsWith("dms");
            });

          const keyrole = timeprevRoles.length > 0 ? JSON.stringify(timeprevRoles) : decodedToken.sub;
          localStorage.setItem('keyrole', keyrole);
        } else {
          localStorage.setItem('keyrole', decodedToken.sub);
        }





    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    console.log('✅ Token processed and stored:');
    console.log('KeycloakService username:', keyusername);
    console.log('KeycloakService timereport role:', localStorage.getItem('keyrole'));
    console.log('KeycloakService timereport idazienda:', keyidazienda);
    console.log('KeycloakService timereport codclifor:', keycodclifor);
    console.log('KeycloakService timereport coddip:', keycoddip);
    console.log('Gamma coddip:', keycoddip);
}
